// extracted by mini-css-extract-plugin
module.exports = {"modal_footer":"missendeGegevensModal_modal_footer__1KsA6"};